import styled from 'styled-components';

export const KpiAtualOutcomeWrapper = styled.div`

.react-datepicker__input-container{
    width: 156px;
}
.kpi-outcome-record h2{
    font-size: 23px;
    font-weight: 700;
    letter-spacing: 0.33px;
    color: #000000;
    margin-bottom: 20px; 
}
.floats-toolbar {
    right: 32%;
}
.new-kpi-col .bg-white{
    padding:0;
}
.manage-createKPI .form-group .input-group{
    position-relative;
}
.input-group>.react-datepicker-wrapper{
    position: relative;
    flex: 1 1;
    min-width: 0;
    margin-bottom: 0;
}
.react-datepicker__input-container {
    width: 100%;
}
.accordion-kpi {
    padding: 0;
}
input{
    outline:none !important;
}
.audit-modal .react-datepicker-wrapper {
    width: 100%;
}

`;